<template>
  <div class="pages">
    <div class="fanhui" @click="goback">返回</div>
    <div id="container"></div>
  </div>
</template>

<script>

import AMap from 'AMap'
import {
  getUserPathWeb
} from '@/api/wms-stock'
export default {
  name: 'guijiDialog',
  data () {
    return {
      map: null,
      marker: null,
      polyline: null,
      lineArr: []
    }
  },
  methods: {
    move () {
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lineArr[0],
        icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/cat.png',
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      // 绘制轨迹
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        showDir: true,
        strokeColor: '#28F', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      var passedPolyline = new AMap.Polyline({
        map: this.map,
        // path: this.lineArr,
        strokeColor: '#AF5', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      this.marker.moveAlong(this.lineArr, 500)
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.map.setFitView()
    },
    initMap () {
      getUserPathWeb({ inventoryPersonId: this.$route.query.id }).then(res => {
        console.log(res)
        if (res.length > 0) {
          res.forEach(item => {
            this.lineArr.push([item.y_point, item.x_point])
          })
          this.map = new AMap.Map('container', {
            center: this.lineArr[0], // [纬度，经度]
            resizeEnable: true,
            zoom: 22
          })
          // 绘制轨迹
          this.polyline = new AMap.Polyline({
            map: this.map,
            path: this.lineArr,
            showDir: true,
            strokeColor: '#28F', // 线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6 // 线宽
            // strokeStyle: "solid"  //线样式
          })
          this.move()
        } else {
          this.$message.error('暂无轨迹回放')
        }

        // this.lineArr
      })
        .catch(err => {
          // this.$message({ message: err.message, type: 'error' })
        })
    },
    goback () {
      this.$router.go(-1)
    }
  },

  mounted () {
  },
  created () {
    this.initMap()
  }
}
</script>

<style lang="less" scoped>
.pages {
  width: 100%;
  height: 100%;
  position: relative;
}
#container {
  width: 100%;
  height: 100%;
}
.fanhui {
  width: 50px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #fff;
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 1000;
  cursor: default;
}
</style>
